import { BrowserRouter, Route, Routes} from 'react-router-dom';
import "@fortawesome/fontawesome-free/css/all.min.css";


import './App.css';

import Nav from './components/Nav';
import Footer from './components/Footer';


import Naslovna from './pages/Naslovna';
import Hero3D from './components/Hero3D.';
import Voditelj from './pages/Voditelj';
import Galerija from './pages/Galerija';
import Lokacija from './pages/Lokacija';
import Prijava from './pages/Prijava';

import LoadingScreen from "./components/LoadingScreen";



function App() {
  return (
  
  <BrowserRouter basename="/">

      <Nav />

    <LoadingScreen />
      <Routes>
        <Route path="/" element={<Naslovna />} />
        <Route path="/voditelj" element={<Voditelj />} />
        <Route path="/Galerija" element={<Galerija />} />
        <Route path="/Lokacija" element={<Lokacija />} />
        <Route path="/Prijava" element={<Prijava />} />
        
      </Routes>

    <Footer />


    </BrowserRouter>
  );
}

export default App;


